var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"r-video"},[(_vm.audio && !_vm.poster)?_c('audio',{attrs:{"controls":""}},[_c('source',{attrs:{"src":_vm.src}})]):_c('video',{ref:"video",staticClass:"img-responsive video-js vjs-theme-sea",attrs:{"controls":"","preload":"auto","poster":_vm.poster}},[_c('source',{attrs:{"src":_vm.src}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }